import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

const AffiliateRetentionProgram = () => {

    const {t} = useTranslation()

    return (
        <div
            className="tab-pane fade show active"
            id="tab-1"
            role="tabpanel"
            aria-labelledby="1-tab"
            tabIndex={0}
        >

            <div className="row">
                <div className="article col-12">
                    <p className="">
                        {t('affiliate.retention-program.d1')}
                    </p>

                    <p className="">
                        {t('affiliate.retention-program.d2')}
                    </p>

                    <p className="">
                        {t('affiliate.retention-program.d3')}
                    </p>
                    <ul>
                        <li>
                            {t('affiliate.retention-program.l1')}
                        </li>

                        <li>
                            {t('affiliate.retention-program.l2')}
                        </li>


                        <li>{t('affiliate.retention-program.l3')}</li>
                        <li>{t('affiliate.retention-program.l4')}</li>
                        <li>{t('affiliate.retention-program.l5')}</li>
                    </ul>

                    <p className="">
                        {t('affiliate.retention-program.d4')}
                    </p>
                    <p className="">
                        {t('affiliate.retention-program.d5')}
                    </p>
                </div>
            </div>

        </div>


    )

}


export default AffiliateRetentionProgram
